import React, { createContext, useContext } from 'react';
import type { ATContextProviderProps } from './types';

export type ATisActiveCtxType = {
  isActive: boolean;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
};

const ATisActiveContext = createContext<ATisActiveCtxType>({
  isActive: false,
  setIsActive: () => null,
});

export const useATisActive = (): ATisActiveCtxType => {
  const ctx = useContext(ATisActiveContext);
  if (ctx === null) {
    throw new Error('useATisActive must be used within a ATisActiveProvider');
  }
  return ctx;
};

export const ATisActiveContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  const [isActive, setIsActive] = React.useState<boolean>(false);

  const value = React.useMemo(
    () => ({
      isActive,
      setIsActive,
    }),
    [isActive],
  );

  return (
    <ATisActiveContext.Provider value={value}>
      {children}
    </ATisActiveContext.Provider>
  );
};
